import { render, staticRenderFns } from "./PerformanceManager.vue?vue&type=template&id=2fd89494&scoped=true&"
import script from "./PerformanceManager.vue?vue&type=script&lang=ts&"
export * from "./PerformanceManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd89494",
  null
  
)

export default component.exports